// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeAndLocation-module--container--2vcbe","date":"TimeAndLocation-module--date--3j2V-"};